<!-- 详情 -->
<template>
  <div class="detail-container">
    <div class="detail-container-content">
      <!-- 1.顶部导航区域 -->
      <div class="header">
        <!-- 1.1左侧返回键和面包屑导航 -->
        <div class="header-nav">
          <slot name="headerNav"></slot>
        </div>
      </div>
      <div class="info-content">
        <slot name="info"></slot>
      </div>
      <!-- 2.内容区域 -->
      <div class="content">
        <!-- 2.1内容描述 -->
        <div v-if="isdescribe" class="describe">
          <!-- 2.1.1描述文字 -->
          <div class="describe-text">
            <div class="describe-icon"></div>
            <slot name="describe"></slot>
          </div>
          <!-- 2.1.2按钮 -->
          <div class="describe-btn">
            <slot name="describeButton"></slot>
          </div>
        </div>
        <!-- 2.2填充内容 -->
        <div class="fill-content">
          <slot name="fill-content"></slot>
        </div>
      </div>
      <!-- 3.统计记录 -->
      <div class="content">
        <!-- 3.1内容描述 -->
        <div v-if="isStatistics" class="describe">
          <!-- 3.1.1描述文字 -->
          <div class="describe-text">
            <div class="describe-icon"></div>
            <slot name="statistics-title"></slot>
          </div>
        </div>
        <!-- 3.2填充内容 -->
        <div class="fill-content">
          <slot name="statistics-content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRefs } from 'vue'
// isdescribe是否显示2.1内容描述
const props = defineProps({
  isdescribe: {
    type: Boolean,
    default: true
  },
  isStatistics:{
    type: Boolean,
    default: false
  }
})
const { isdescribe } = toRefs(props)
</script>

<style lang="scss" scoped>
.detail-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  z-index: 999; /* 保证详情页在最顶层 */
  padding: 10px;
}
.detail-container-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    min-height: 50px;
    background-color: #fff;
    border-bottom: 1px solid #e7e4e4;
    .header-nav {
      display: flex;
      align-items: center;
    }
    :deep(.el-button .el-icon) {
      font-size: 24px;
    }
  }
  .info-content{
    padding: 10px;
  }
  .content {
    flex: 1;
    background-color: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    border-top: 10px solid #f2f2f2;
    .describe {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      .describe-text {
        display: flex;
        align-items: center;
      }
      .describe-btn{
        color: #1684FC;
        cursor: pointer;
      }
      .describe-icon {
        width: 5px;
        height: 15px;
        background-color: #1b77fb;
        margin: 0 5px;
      }
    }
    .fill-content {
      flex: 1;
    }
  }
}
</style>
